
<script>
import canvasBase from "./CanvasBase.vue";
import { limit,debounce } from "../../helpers/utils";
export default {
  extends: canvasBase,
  name: "canvasAnnotation",
  props: {
    annotation: Object
  },
  methods: {
    draw() {
      if (this.annotation) this.annotation.canvasSize = this.canvasSize;
      if (this.renderer){
        this.renderer.limitDrawAnnotation(this.annotation);
        this.renderer.debounceDrawAnnotation(this.annotation);
      } 
    },
    setupAnnotationRedraw(){
      if (this.annotation && this.annotation.setReadyCallback)
        this.annotation.setReadyCallback(this.redraw);
      this.redraw();
    },
    setupDrawCall(){
      this.renderer.limitDrawAnnotation = limit(this.renderer.drawAnnotation.bind(this.renderer), 20);
      this.renderer.debounceDrawAnnotation = debounce(this.renderer.drawAnnotation.bind(this.renderer), 20);
    }
  },
  watch: {
    annotation(){
      this.setupAnnotationRedraw();
    }
  },
  mounted(){
    this.setupAnnotationRedraw();
  }
};
</script>